// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"489883c8","453":"86d9bba5"}[chunkId] + ".chunk.js";
};